import { storageService } from '@/services/firebase/storage.service'

/**
 * Obtiene la URL de descarga de una imagen desde Firebase Storage
 * @param imagePath - Ruta del archivo en storage (ej: "images/123456_photo.jpg")
 * @returns URL de descarga o null si hay error
 */
export const getImageUrl = async (imagePath: string): Promise<string | null> => {
  if (!imagePath) return null

  try {
    const url = await storageService.getFileURL({
      path: `images/${imagePath}`
    })
    return url
  } catch (error) {
    console.error('Error getting image URL:', error)
    return null
  }
}

/**
 * Hook para cargar URL de imagen de forma segura
 * Maneja errores y retorna null si falla
 */
export const useImageUrl = (imagePath: string | null | undefined) => {
  if (!imagePath) return null
  return imagePath // Si es una URL completa, devolverla directamente
}
